import { Button, Col } from "react-bootstrap";

export const ProjectCard = ({ title, description, imgUrl,live,github }) => {
  return (
    <Col size={12} sm={6} md={4}>
      <div className="proj-imgbx">
        <img src={imgUrl} />
        <div className="proj-txtx">
          <h4>{title}</h4>
          <span>{description}</span>
        </div>
        <div className="proj-txtx" style={{ margin: "80px 15px" }}>
          <Button className="btn btn-info btn-sm">
            <a href={live} target="_blank">Live Preview</a>
          </Button>
          <Button className="btn btn-warning btn-sm">
            <a href={github} target="_blank">GitHub Code</a>
          </Button>
        </div>
      </div>
    </Col>
  );
};
